// import Swiper from 'swiper'
// import 'swiper/css'

// import { Autoplay } from 'swiper/modules'
import { find } from 'utils/dom'

export default function () {
	const Home = find("[js-page='home']")
	if (!Home) return

	// 	const swiperSpeed = new Swiper('.swiperBanner', {
	// 		slidesPerView: 'auto',
	// 		spaceBetween: 32,
	// 		loop: true,
	// 		modules: [Autoplay],
	// 		speed: 5000,
	// 		allowTouchMove: false,
	// 		centerInsufficientSlides: 'true',
	// 		autoplay: {
	// 			delay: 0,
	// 			disableOnInteraction: false,
	// 		},

	// 		on: {
	// 			init: function () {
	// 				this.el.querySelector('.swiper-wrapper').style.transitionTimingFunction = 'linear'
	// 				this.el.querySelector('.swiper-wrapper').style.willChange = 'transform'
	// 			},
	// 		},

	// 		breakpoints: {
	// 			1024: {
	// 				spaceBetween: 57,
	// 			},
	// 		},
	// 	})

	document.addEventListener('DOMContentLoaded', () => {
		const overlay = document.getElementById('playOverlay')
		const placeholder = document.getElementById('placeholder')
		const iframe = document.getElementById('vimeo-player')

		overlay.addEventListener('click', function () {
			overlay.style.display = 'none'
			placeholder.style.display = 'none'

			const videoUrl = `${window.video_institucional}?autoplay=1&playsinline=1`
			iframe.src = videoUrl

			const player = new Vimeo.Player(iframe)

			player.play().catch(function (error) {
				console.warn('Erro ao tentar reproduzir o vídeo:', error)
			})
		})
	})
}
